import * as tslib_1 from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import UpNextExpansion from './UpNextExpansion';
import getWeatherImage from '../utils/getWeatherImage';
import store from '../store/store';
import strings from 'owa-strings/owa-common-strings';
import toggleAgenda from '../actions/toggleAgenda';
import toggleExpansion from '../actions/toggleExpansion';
import { ContextualMenu, } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { format } from 'owa-strings';
import { getOwaUrlWithAddedQueryParameters } from 'owa-url';
import { reactive } from 'satcheljs/lib/legacy/react';
import { formatShortTime } from 'owa-datetime-format';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
var styles = require('./UpNext.scss');
var classNames = require('classnames/bind');
var MINUTE_IN_MILLISECONDS = 60 * 1000;
var FIVE_MINUTES_IN_MILLISECONDS = 5 * MINUTE_IN_MILLISECONDS;
var TWENTY_MINUTES_IN_MILLISECONDS = 20 * MINUTE_IN_MILLISECONDS;
var UpNext = /** @class */ (function (_super) {
    tslib_1.__extends(UpNext, _super);
    function UpNext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpNext.prototype.render = function () {
        var _this = this;
        var meetings = this.props.calendarItems.values();
        var agendaMeetings = [];
        var name;
        var location;
        var time;
        var isMeetingIn5MinRange;
        if (!meetings || meetings.length == 0) {
            name = strings.noEvents;
        }
        else {
            var nextMeeting = void 0;
            var fiveMinutesAgo = this.getFiveMinutesAgoDate();
            for (var _i = 0, meetings_1 = meetings; _i < meetings_1.length; _i++) {
                var meeting = meetings_1[_i];
                agendaMeetings.push({
                    key: meeting.ItemId.Id,
                    name: formatShortTime(new Date(meeting.Start)) +
                        ' - ' +
                        meeting.Subject +
                        ' ● ' +
                        meeting.Location.DisplayName,
                });
                if (!nextMeeting && new Date(meeting.Start) > fiveMinutesAgo) {
                    // We found the next meeting.
                    nextMeeting = meeting;
                }
            }
            // Grab the info out of the next meeting.
            if (nextMeeting) {
                name = nextMeeting.Subject;
                location = nextMeeting.Location.DisplayName;
                var now = new Date();
                var meetingStart = new Date(nextMeeting.Start);
                var isTodayMeeting = new Date().toDateString() == meetingStart.toDateString();
                var millisecondsDifference = now.getTime() - meetingStart.getTime();
                if (millisecondsDifference >= 0 &&
                    millisecondsDifference <= FIVE_MINUTES_IN_MILLISECONDS) {
                    time = strings.now;
                }
                else if (millisecondsDifference < 0 &&
                    Math.abs(millisecondsDifference) <= TWENTY_MINUTES_IN_MILLISECONDS) {
                    var minutes = Math.ceil(Math.abs(millisecondsDifference) / MINUTE_IN_MILLISECONDS);
                    time = minutes <= 1 ? strings.inOneMinute : format(strings.inXMinutes, minutes);
                }
                else {
                    // Regular time.
                    time = format(isTodayMeeting ? strings.todayAt : strings.tomorrowAt, formatShortTime(meetingStart));
                }
            }
            else {
                // No next meeting.
                name = strings.noMoreEvents;
            }
        }
        agendaMeetings.push({
            key: 'agendaToCalendar',
            name: strings.goToCalendar,
            icon: "Calendar" /* Calendar */,
            onClick: function () {
                return window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/calendar' }));
            },
        });
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.container },
                this.renderWeatherCharms(),
                React.createElement("div", { className: styles.left },
                    React.createElement("span", { className: styles.next }, strings.next),
                    React.createElement("span", { className: styles.name, title: name }, name),
                    React.createElement("span", { className: styles.location, title: location }, location)),
                React.createElement("div", { className: styles.right },
                    React.createElement("span", { className: classNames(isMeetingIn5MinRange && styles.important, styles.time) }, time),
                    React.createElement(IconButton, { ref: function (ref) { return (_this.agendaRef = ReactDOM.findDOMNode(ref)); }, onClick: this.toggleAgendaClick, className: styles.agenda, iconProps: { iconName: "Calendar" /* Calendar */ } }),
                    store.isAgendaOpen && (React.createElement(ContextualMenu, { shouldFocusOnMount: true, isBeakVisible: true, target: this.agendaRef, gapSpace: 5, directionalHint: 11 /* rightTopEdge */, onDismiss: this.toggleAgendaClick, items: agendaMeetings })))),
            store.isExpansionOpen && React.createElement(UpNextExpansion, null)));
    };
    UpNext.prototype.renderWeatherCharms = function () {
        var weatherClasses = classNames(styles.weather, !this.props.isExpansionOpen && styles.withNoExpansion);
        return (this.props.weatherDailyConditions && (React.createElement("a", { className: weatherClasses, href: store.weatherClickThrough, onClick: this.toggleExpansionClick, target: "_blank" },
            React.createElement("div", { className: styles.weatherInnerContainer }, this.props.weatherDailyConditions.map(function (item, index) {
                var weatherCharmClasses = classNames(styles.weatherIcon, index == 0 ? styles.currentWeather : styles.forecastWeather, getWeatherImage(item.SkyCode), getWeatherImage()); // Fallback css image.
                return (React.createElement("i", { key: 'wi' + index, className: weatherCharmClasses, title: item.SkyText }));
            })))));
    };
    UpNext.prototype.toggleExpansionClick = function (ev) {
        toggleExpansion();
    };
    UpNext.prototype.toggleAgendaClick = function (ev) {
        ev.stopPropagation();
        toggleAgenda();
    };
    UpNext.prototype.getFiveMinutesAgoDate = function () {
        var fiveMinutesAgo = new Date();
        fiveMinutesAgo.setTime(fiveMinutesAgo.getTime() - FIVE_MINUTES_IN_MILLISECONDS);
        return fiveMinutesAgo;
    };
    UpNext = tslib_1.__decorate([
        reactive({
            calendarItems: function () { return store.calendarItems; },
            isAgendaOpen: function () { return store.isAgendaOpen; },
            isExpansionOpen: function () { return store.isExpansionOpen; },
            weatherClickThrough: function () { return store.weatherClickThrough; },
            weatherDailyConditions: function () { return store.weatherDailyConditions; },
        })
    ], UpNext);
    return UpNext;
}(React.Component));
export default UpNext;
//# sourceMappingURL=UpNext.js.map